import MapDataStream from "../MapDataStream";

export default class MapElementDataStream extends MapDataStream {
    constructor(id, forceAllVisible = false) {
        super(id);

        this.forceAllVisible = forceAllVisible;
        this.mapElements = [];
        this.selectedMapElements = [];
        this.visibleMapElements = [];
    }

    initialize(mapElements) {
        this.setMapElements(mapElements, true);
    }

    setMapElements(mapElements, subscribeToMapElements = false) {
        this.mapElements = mapElements;

        if (subscribeToMapElements) {
            for (const mapElement of mapElements) {
                mapElement.observe().subscribe((fieldInfo) => {
                    if (fieldInfo.field == "selected" || fieldInfo.field == "highlighted") {
                        if (fieldInfo.value == true) {
                            this.selectedMapElements.push(mapElement);
                        } else {
                            this.selectedMapElements = this.selectedMapElements.filter((element) => {
                                if (!element.isSelected() && !element.isHighlighted()) {
                                    return element != mapElement;
                                } else {
                                    return true;
                                }
                            });
                        }

                        for (var selectionSubscriber of this.selectionSubscribers) {
                            selectionSubscriber.next(this.selectedMapElements);
                        }
                    } else if (fieldInfo.field == "hidden") {
                        this._update();
                    }
                });
            }
        }

        this._update();
    }

    _update() {
        this.visibleMapElements = [];

        if (this.mapElements) {
            for (const mapElement of this.mapElements) {
                if (!mapElement.isHidden() || this.forceAllVisible) {
                    this.visibleMapElements.push(mapElement);
                }
            }
        }

        for (var subscriber of this.subscribers) {
            subscriber.next(this.visibleMapElements);
        }
    }

    getGeoJSONFeatures() {
        throw new Error("Method must be overriden in subclasses.");
    }
}
